import type React from "react";
import { useState } from "react";
import type { Asset } from "utils/object";
import AssetRetireModal from "./AssetRetireModal";
import RetireAssetButton from "./RetireAssetButton";

interface RetireAssetButtonWithModalProps {
  asset: Asset;
  onSuccess?: () => void;
}

export default function RetireAssetButtonWithModal({
  asset,
  onSuccess,
}: RetireAssetButtonWithModalProps): React.ReactElement {
  const [isRetireModalOpen, setIsRetireModalOpen] = useState(false);

  return (
    <>
      <AssetRetireModal
        asset={asset}
        isOpen={isRetireModalOpen}
        onClose={() => setIsRetireModalOpen(false)}
        onSuccess={onSuccess}
      />
      <RetireAssetButton onClick={() => setIsRetireModalOpen(true)} />
    </>
  );
}
